export default __webpack_public_path__ + "static/media/Rplot01 1.bda08c2d.svg";